export default "__VITE_ASSET__DeN4aGif__"